// gclid / fbclid / ttclid of the URL kept for the next pages (bootstrap.ts of the Vue app, blade-app.ts)
import "./storeUtm";
import "./simulator/layout";
import { flushPendingExposures } from "./analytics/posthog-exposure";

flushPendingExposures();

// Sentry client of the Blade pages (Vue: @sentry/vue), loaded when idle like blade-app.ts
function initSentryWhenIdle(): void {
    void import("./sentry-blade");
}
if ("requestIdleCallback" in window) {
    requestIdleCallback(() => initSentryWhenIdle(), { timeout: 5000 });
} else {
    setTimeout(initSentryWhenIdle, 3000);
}

// partials/login-modal of the layout (Start.vue « Connectez-vous »: LoginCard in a Modal), loaded on
// demand like blade-app.ts does. No blade-app here: the Inertia tunnel has no RudderStack client.
let loginModalPromise: Promise<typeof import("./shared/login-modal")> | null =
    null;
window.addEventListener("open-login-modal", () => {
    loginModalPromise ??= import("./shared/login-modal");
    void loginModalPromise.then((mod) => mod.openLoginModal());
});

if (document.getElementById("simulation-start-root")) {
    void import("./simulator/start");
} else if (document.getElementById("simulation-resume-root")) {
    void import("./simulator/resume");
} else if (document.getElementById("simulation-code-root")) {
    void import("./simulator/code");
}
// Remerciement : rien à charger, son entrée est en CSS (_tunnel.scss), visible sans JavaScript
